import React from 'react';

// COMPONENTS
import { Button } from '../../../UI/Button';

// STYLES
import { ActionButtons, Close, ModalContainer, ModalContent, ModalTitle, ModalSubtitle } from '../styles';

// SVGS
import { AnalysisProposal } from '../svgs';

import { useNavigate } from 'react-router-dom';

interface IModalErrorProposalInconsistent {
  onClose: any;
}

const ModalAnalysisProposal = ({ onClose }: IModalErrorProposalInconsistent) => {
  const navigate = useNavigate();

  return (
    <ModalContent>
      <ModalContainer>
        <AnalysisProposal />
        <ModalTitle>Esta proposta já foi registrada.</ModalTitle>
      </ModalContainer>
      <ModalSubtitle>
        Não foi possível prosseguir com a submissão da proposta, pois já existe uma proposta registrada com os mesmos
        dados. Por favor, revise as informações ou entre em contato com o suporte.
      </ModalSubtitle>
      <ActionButtons className="left">
        <Button onClick={() => navigate('/manage-proposal')} big black>
          Gerenciar propostas
        </Button>
        <Button onClick={onClose} big transparent>
          Nova proposta
        </Button>
      </ActionButtons>
    </ModalContent>
  );
};

export default ModalAnalysisProposal;
